const featureInfos = {
  aqi: {
    // 严重污染
    serious: {
      value: 300, color: '#711425', gaoChunColor: '#976C7B', fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 200, color: '#8a1b4b', gaoChunColor: '#9872B2', fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 150, color: '#e73323', gaoChunColor: '#E16864', fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度',color01: 'rgb(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 100, color: '#ec8532', gaoChunColor: '#E79458', fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 50, color: '#fefe55', gaoChunColor: '#F1CF58', fontColor: 'rgb(68, 67, 0)', textColor: 'rgb(255, 255, 255)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#6ee043', gaoChunColor: '#AAD663', fontColor: 'rgb(68, 67, 0)', textColor: 'rgb(255, 255, 255)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  pm10: {
    // 严重污染
    serious: {
      value: 420, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 350, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 250, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 150, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 50, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  pm25: {
    // 严重污染
    serious: {
      value: 250, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 150, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 115, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 75, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 35, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  o3: {
    // 严重污染
    serious: {
      value: 800, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 400, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 300, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 200, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 160, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  co: {
    // 严重污染
    serious: {
      value: 36, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 24, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 14, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 4, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 2, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  so2: {
    // 严重污染
    serious: {
      value: 1600, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 800, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 475, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 150, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 50, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  no2: {
    // 严重污染
    serious: {
      value: 565, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'serious', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 280, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'severe', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 180, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'moderate', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 80, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'mild', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 40, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'good', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'optimal', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  // tvoc指标
  t: {
    // 严重污染
    serious: {
      value: 565, color: '#7E0100',fontColor: 'rgb(68, 67, 0)', emo: 'nodata', txt: '严重污染',color01: 'rgba(126, 1, 0, .2)',
    },
    // 重度污染
    severe: {
      value: 280, color: '#81007F',fontColor: 'rgb(68, 67, 0)', emo: 'nodata', txt: '重度污染',color01: 'rgba(129, 0, 127, .2)',
    },
    // 中度污染
    moderate: {
      value: 180, color: '#FE0000',fontColor: 'rgb(68, 67, 0)', emo: 'nodata', txt: '中度污染',color01: 'rgba(254, 0, 0, .2)',
    },
    // 轻度污染
    mild: {
      value: 80, color: '#FF7D00',fontColor: 'rgb(68, 67, 0)',emo: 'nodata', txt: '轻度污染',color01: 'rgba(255, 125, 0, .2)',
    },
    // 良
    good: {
      value: 40, color: '#FFFE05',fontColor: 'rgb(68, 67, 0)',emo: 'nodata', txt: '良',color01: 'rgba(254, 254, 5, .2)',
    },
    // 优
    optimal: {
      value: 0, color: '#00E700',fontColor: 'rgb(68, 67, 0)', emo: 'nodata', txt: '优',color01: 'rgba(0, 231, 0, .2)',
    },
  },
  tem: {
  // 40摄氏度
    hot: {
      value: 40, color: '#EEAC07', fontColor: '#fff', emo: 'hot',
    },
    // 30摄氏度
    summer: {
      value: 30, color: '#AFA500', fontColor: '#fff', emo: 'summer',
    },
    // 20摄氏度
    serious: {
      value: 20, color: '#739200', fontColor: '#fff', emo: 'serious',
    },
    // 10摄氏度
    severe: {
      value: 10, color: '#65935F', fontColor: '#fff', emo: 'severe',
    },
    // 0摄氏度
    moderate: {
      value: 0, color: '#5FA2C4', fontColor: '#fff', emo: 'moderate',
    },
    // -10摄氏度
    mild: {
      value: -10, color: '#80C1C5', fontColor: '#fff',emo: 'mild',
    },
    // -20摄氏度
    good: {
      value: -20, color: '#8F8FD1', fontColor: 'rgb(68, 67, 0)',emo: 'good',
    },
    optimal: {
      value: -99, color: '#8F8FD1', fontColor: 'rgb(68, 67, 0)', emo: 'optimal',
    },
  },
  prs: {
    serious: {
      value: 1030, color: '#A0522D', fontColor: 'rgb(68, 67, 0)', emo: 'severe',
    },
    severe: {
      value: 1020, color: '#D9B066', fontColor: 'rgb(68, 67, 0)', emo: 'severe',
    },
    moderate: {
      value: 1010, color: '#75D7BE', fontColor: 'rgb(68, 67, 0)', emo: 'moderate',
    },
    mild: {
      value: 1000, color: '#00ACBD', fontColor: 'rgb(68, 67, 0)',emo: 'mild',
    },
    good: {
      value: 990, color: '#016794', fontColor: 'rgb(68, 67, 0)',emo: 'good',
    },
    optimal: {
      value: 0, color: '#00E700', fontColor: 'rgb(68, 67, 0)', emo: 'optimal',
    },
  },
  rhu: {
    serious: {
      value: 100, color: '#384875', fontColor: 'rgb(68, 67, 0)', emo: 'serious',
    },
    severe: {
      value: 90, color: '#3885AE', fontColor: 'rgb(68, 67, 0)', emo: 'severe',
    },
    moderate: {
      value: 80, color: '#399EAE', fontColor: 'rgb(68, 67, 0)', emo: 'moderate',
    },
    mild: {
      value: 50, color: '#69AE39', fontColor: 'rgb(68, 67, 0)',emo: 'mild',
    },
    good: {
      value: 30, color: '#AD6E38', fontColor: 'rgb(68, 67, 0)',emo: 'good',
    },
    optimal: {
      value: 0, color: '#00E700', fontColor: 'rgb(68, 67, 0)', emo: 'optimal',
    },
  },
  pre: {
    severe: {
      value: 50, color: '#0100BF', fontColor: 'rgb(68, 67, 0)', emo: 'severe',
    },
    moderate: {
      value: 25, color: '#335DFE', fontColor: 'rgb(68, 67, 0)', emo: 'moderate',
    },
    mild: {
      value: 10, color: '#43B157', fontColor: 'rgb(68, 67, 0)',emo: 'mild',
    },
    good: {
      value: 0, color: '#89E065', fontColor: 'rgb(68, 67, 0)',emo: 'good',
    },
    optimal: {
      value: 0, color: '#fff', fontColor: 'rgb(68, 67, 0)', emo: 'optimal',
    },
  },
};

const siteInfos = {
  country: {
    iconSIze: [40, 40,],
    type: 1,
  },
  province: {
    iconSIze: [36, 36,],
    type: 2,
  },
  city: {
    iconSIze: [40, 40,],
    type: 3,
  },
  micro: {
    iconSIze: [36, 36,],
    type: 4,
  },
};

/**
 * factor值对应属性
 * @param {number} value 值
 * @param {string} factor 要素
 * @returns {string} void
 */
export function setFeatureThresholdInfo (value: number, factor: string): any {
  const factorInfo = featureInfos[factor];
  const nodata:any = {
    emo: 'nodata',
    txt: '空',
    eleValue: '',
  };

  switch (true) {
  case value > factorInfo?.serious?.value:
    factorInfo.serious.eleValue = value;

    return factorInfo.serious;
  case value > factorInfo.severe.value:
    factorInfo.severe.eleValue = value;

    return factorInfo.severe;
  case value > factorInfo.moderate.value:
    factorInfo.moderate.eleValue = value;

    return factorInfo.moderate;
  case value > factorInfo.mild.value:
    factorInfo.mild.eleValue = value;

    return factorInfo.mild;
  case value > factorInfo.good.value:
    factorInfo.good.eleValue = value;

    return factorInfo.good;
  case value >= factorInfo.optimal.value:
    factorInfo.optimal.eleValue = value;

    return factorInfo.optimal;
  case value === -9999 || value === 99999 || value === 999999:

    return nodata;
  default:
    return nodata;
  }
}

/**
 * factor值对应属性
 * @param {string} status 状态
 * @returns {string} void
 */
export function setFeatureThresholdInfoStatic (status:string): string {
  let str = 'normal';

  switch (status) {
  case '1':
    str = 'disconnected';
    break;
  case '2':
    str = 'high';
    break;
  case '4':
    str = 'normal';
    break;
  case '5':
    str = 'excess';
    break;
  case '3':
    str = 'abnormal';
    break;
  case '6':
    str = 'warn';
    break;
  case '7':
    str = 'worst';
    break;
  default:
    break;
  }

  return str;
}

/**
 * 获取建议
 * @param {number} aqi AQI的值
 * @returns {string} 建议
 */
export function getAqiSuggestion (aqi: number): string {
  if (aqi === null || aqi === -9999 || aqi === 99999) {
    return '-';
  }
  if (aqi <= 50) {
    return '各类人群可正常活动';
  }
  if (aqi <= 100) {
    return '极少数异常敏感人群应减少户外活动';
  }
  if (aqi <= 150) {
    return '儿童、老年及心脏病、呼吸系统疾病患者避免长时间、高强度的户外锻炼';
  }
  if (aqi <= 200) {
    return '儿童、老年及心脏病、呼吸系统疾病患者避免长时间、高强度的户外锻炼，一般人群适量减少户外活动';
  }
  if (aqi <= 300) {
    return '儿童、老年及心脏病、肺病患者应停留在室内，停止户外运动，一般人群减少户外运动';
  }
  if (aqi > 300) {
    return '儿童、老年人和病人应停留在室内，避免体力消耗，一般人应避免户外活动';
  }

  return '-';
}

/**
 *  风向
 * @param {any} data 传入风向（度数）
 * @returns {string} 返回风向
 */
export function windDirection (data: number): string {
  if (data >= 22.5 && data < 67.5) {
    return '东北风';
  }
  if (data >= 67.5 && data < 112.5) {
    return '东风';
  }
  if (data >= 112.5 && data < 157.5) {
    return '东南风';
  }
  if (data >= 157.5 && data < 202.5) {
    return '南风';
  }
  if (data >= 202.5 && data < 247.5) {
    return '西南风';
  }
  if (data >= 247.5 && data < 292.5) {
    return '西风';
  }
  if (data >= 292.5 && data < 337.5) {
    return '西北风';
  }
  if ((data >= 337.5 && data < 360) || (data >= 0 && data < 22.5)) {
    return '北风';
  }

  return '--';
}

/*
 * 静态数据类型
 * 类型：工业企业、餐饮、工地、汽修、锅炉、炉窖、堆场、停车场、加油站
 * 还有在线、清单区分，例如cookingFume（在线餐饮），cookingFumeList（清单餐饮）
 */
const staticDataType = ['cookingFume',
  'construction',
  'company',
  'yard',
  'park',
  'cookingFumeList',
  'constructionList',
  'companyList',
  'yardList',
  'parkList',
  'muckParkList',
  'repairList',
  'repair',
  'satellitePoint',
  'monitorPoint',
  'boiler',
  'furnace',
  'boilerList',
  'oilList',
  'furnaceList',];

// 获取聚合状态下 图标及文字
export const setClusterFeature = (nodeType:string,count:number,datas:any,elementType:string) :any => {
  if (staticDataType.includes(nodeType)) {
    // 聚合状态优先级
    const statusRight = ['4',
      '2',
      '5',
      '1',
      '3',];
      // 默认optimal
    let statusIndex = statusRight.indexOf('4');

    datas.forEach((item: any) => {
      const curIndex = statusRight.indexOf(item.markInfo.status);

      if (curIndex > statusIndex) {
        statusIndex = curIndex;
      }
    });

    const emo = setFeatureThresholdInfoStatic(statusRight[statusIndex]);

    return { text: count,emo, };
  }
  // 计算环境站点
  let total: any = 0;
  let notComputedCount = 0;

  datas.forEach((item: any) => {
    if (
      total !== '-' &&
      item.value !== 0 &&
      Number(item.value) &&
      item.value !== '-9999' &&
      item.value !== '999999' &&
      item.value !== '-'
    ) {
      total += Number(item.value);
    } else {
      // 不满足条件的数量，聚合平均值计算的时候要减去这个值
      notComputedCount++;
    }
  });
  // const average = total / (count - notComputedCount);

  // 计算平均值的时候要用参与聚合的点的数量（datas.length）减去不满足条件的数量，而不是用所有点的数量(count)
  const average = total / (datas.length - notComputedCount);
  const text = total === 0 ? '-' : average.toFixed(0);

  const markFeaturecCluster = setFeatureThresholdInfo(average, elementType);

  return {
    text,
    emo: markFeaturecCluster.emo,
  };
};

// 获取非聚合状态下 图标及文字
export const setMarkerrFeature = (nodeType:string,markInfo:any,elementType:string) :any => {
  if (staticDataType.includes(nodeType)) {
    const emo = setFeatureThresholdInfoStatic(markInfo.status);

    return { text: '', emo, };
  }

  // 环境站点
  const value = markInfo[elementType];

  const ValueText = value || Number(value) ? parseFloat(Number(value).toFixed(2)) :
    '-';

  return {
    text: ValueText,
    emo: markInfo[`c${elementType}`] || 'nodata',
  };
};
